export class TemplateWrapperComponent {
    public template = require('./wrapper.html');
}
